export default __webpack_public_path__ + "static/media/slot.809c86d6.webp";